import { signOut } from '@auth/services/signOut';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { clearImpersonatedUser } from '../user/reducer';
import { clearSession } from './reducer';

const logout = createAsyncThunk('Session/Logout', async (_, thunkAPI) => {
  try {
    await signOut();
  } catch (error) {
    console.error(error);
  } finally {
    thunkAPI.dispatch(clearSession());
    thunkAPI.dispatch(clearImpersonatedUser());
  }
});

export { logout };
